import React from 'react';
import { Select } from './ui/Select';
import { FilterState, TimeRange } from '../types/salesMetrics';
import { CalendarIcon, UsersIcon, UserIcon } from 'lucide-react';
interface FilterBarProps {
  filters: FilterState;
  onFilterChange: (newFilters: FilterState) => void;
  teams: {
    id: string;
    name: string;
  }[];
  loanOfficers: {
    id: string;
    name: string;
    teamId: string;
  }[];
}
export function FilterBar({
  filters,
  onFilterChange,
  teams,
  loanOfficers
}: FilterBarProps) {
  const handleDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      ...filters,
      dateRange: e.target.value as TimeRange
    });
  };
  const handleTeamChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      ...filters,
      selectedTeamId: e.target.value,
      selectedLoId: 'all' // Reset LO when team changes
    });
  };
  const handleLoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({
      ...filters,
      selectedLoId: e.target.value
    });
  };
  // Filter LOs based on selected team
  const filteredLos = filters.selectedTeamId === 'all' ? loanOfficers : loanOfficers.filter(lo => lo.teamId === filters.selectedTeamId);
  return <div className="bg-white border-b border-slate-200 px-6 py-4 flex flex-col sm:flex-row gap-4 items-end sm:items-center justify-between sticky top-0 z-10 shadow-sm" data-id="element-55">
      <div className="flex flex-wrap gap-4 w-full" data-id="element-56">
        <div className="w-full sm:w-48" data-id="element-57">
          <Select label="Time Period" value={filters.dateRange} onChange={handleDateChange} icon={<CalendarIcon className="w-4 h-4" data-id="element-59" />} data-id="element-58">
            <option value="today" data-id="element-60">Today</option>
            <option value="yesterday" data-id="element-61">Yesterday</option>
            <option value="7days" data-id="element-62">Last 7 Days</option>
            <option value="30days" data-id="element-63">Last 30 Days</option>
          </Select>
        </div>

        <div className="w-full sm:w-48" data-id="element-64">
          <Select label="Team" value={filters.selectedTeamId} onChange={handleTeamChange} icon={<UsersIcon className="w-4 h-4" data-id="element-66" />} data-id="element-65">
            <option value="all" data-id="element-67">All Teams</option>
            {teams.map(team => <option key={team.id} value={team.id} data-id="element-68">
                {team.name}
              </option>)}
          </Select>
        </div>

        <div className="w-full sm:w-48" data-id="element-69">
          <Select label="Loan Officer" value={filters.selectedLoId} onChange={handleLoChange} disabled={filteredLos.length === 0} icon={<UserIcon className="w-4 h-4" data-id="element-71" />} data-id="element-70">
            <option value="all" data-id="element-72">All Loan Officers</option>
            {filteredLos.map(lo => <option key={lo.id} value={lo.id} data-id="element-73">
                {lo.name}
              </option>)}
          </Select>
        </div>
      </div>

      <div className="text-xs text-slate-400 font-medium whitespace-nowrap" data-id="element-74">
        Last updated: Just now
      </div>
    </div>;
}